import Cookies from 'js-cookie'
import store from '../store/index.js'

function Authorization(to, next) {
    let needNext = true;
    debugger
    //判断路由中是否存在SeesionKey、Account、Token、PassWord、Ticket参数，若存在则是第一次登录传递的参数，需要保存后处理掉该参数
    if (to.query["SessionKey"]) {
        let cookiesValue = 'username=' + to.query["Account"] + '&SessionKey=' + to.query["SessionKey"] + '&&password=' + to.query["PassWord"];
        if (Cookies.get(_myconfig.cookies)) {
            Cookies.remove(_myconfig.cookies);
        }
        Cookies.set(_myconfig.cookies, cookiesValue, { expires: 3 });
        store.commit("saveToken", to.query["Ticket"]);
        //去除sso传来的参数并重新定向
        let queryParam = {};
        for (var p in to.query) {
            if (p != "SessionKey" && p != "Account" && p != "PassWord" && p != "Token" && p != "Ticket") {
                queryParam[p] = to.query[p];
            }
        }
        next({ path: to.path, query: queryParam });
        needNext = false;
    }
    if (!store.state.token) {//如果没有，优先去缓存取
        store.commit("saveToken", window.localStorage.Token)
    }
    if (!(store.state.token && store.state.token != "undefined")) {//如果未发现token,重置stroe，token状态，跳转到sso登录
        store.commit("saveToken", "");
        RedirectLogin();//跳转到sso登录页面
        needNext = false;
    }
    //当访问的路径在菜单数据中不存在，这里暂时不做判断了，即只要路由中配置了path的，手动输入均可访问

    return needNext;
}

function RedirectLogin() {
    let to = window.location.href;
    let loginUrl = _myconfig.loginUrl + "SSO/Login?RedirectUrl=" + encodeURIComponent(to) + "&sysid=" + _myconfig.sysid;
    //let loginUrl = _myconfig.loginUrl + "SSO/Login?RedirectUrl=111&sysid=" + _myconfig.sysid;
    window.location.href = loginUrl;
}

export default {
    Authorization: function (to, next) {
        return Authorization(to, next);
    }
}